import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { UseFormReturn } from 'react-hook-form';

interface SwitchFieldProps {
  name: string;
  label: string;
  description: string;
  disabled?: boolean;
  form: UseFormReturn<any>;
  className?: string;
  labelSize?: 'sm' | 'base';
}

export const SwitchField: React.FC<SwitchFieldProps> = ({ 
  name, 
  label, 
  description, 
  disabled = false, 
  form,
  className,
  labelSize = 'sm'
}) => (
  <FormField
    control={form.control}
    name={name}
    render={({ field }) => (
      <FormItem className={`space-y-2 ${className || ''}`}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <FormLabel className={`sm:w-48 sm:flex-shrink-0 ${labelSize === 'sm' ? 'text-sm' : 'text-base'} ${disabled ? "text-muted-foreground" : ""}`}>
            {label}
          </FormLabel>
          <FormControl>
            <div className="flex justify-end w-full sm:w-80">
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={disabled}
              />
            </div>
          </FormControl>
        </div>
        <FormDescription className="text-xs">
          {description}
        </FormDescription>
      </FormItem>
    )}
  />
);